module.exports = __webpack_public_path__ + "img/2b.ad4c6a0f.png";